import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { Intent } from 'ui-toolkit';

interface IFontAwesomeIconColorProps {
  intent?: Intent;
}

const intentToThemeColor = (intent?: Intent) => {
  switch (intent) {
    case undefined:
      return 'defaultContentText';
    case 'secondary':
      return 'blue';
    case 'danger':
      return 'error';
    default:
      // primary, warning.
      return intent;
  }
};

export const FontAwesomeIconColor = styled(FontAwesomeIcon)<IFontAwesomeIconColorProps>`
  color: ${(props) => props.theme.colors[intentToThemeColor(props.intent)]};
`;
